import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import leadershipImage from "../Images/Banner2.png"; // update path if needed

const GrowthLeadershipSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      alignItems="center"
      justifyContent="space-between"
      px={4}
      py={6}
    >
      {/* Left: Image and Caption */}
      <Box flex={1} display="flex" flexDirection="column" alignItems="center">
        <Box
          component="img"
          src={leadershipImage}
          alt="Growth Leadership"
          sx={{
            width: "100%",
            maxWidth: 450,
            borderRadius: 2,
            mb: 2,
          }}
        />
      </Box>

      {/* Right: Stats Block */}
      <Box flex={1} mt={isMobile ? 4 : 0} pl={isMobile ? 0 : 6}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Changes in Talent Acquisition Market
        </Typography>

        <Box display="flex" flexWrap="wrap" gap={4} mt={2}>
          {/* 1 */}
          <Box width={isMobile ? "100%" : "45%"}>
            <Typography
              variant="h4"
              fontWeight="bold"
              color="#3E73DB"
              fontSize={"3rem"}
            >
              43/56
            </Typography>
            <Typography fontSize={"0.9rem"}>
              foundational skills required for job success are human skills
            </Typography>
          </Box>

          {/* 2 */}
          <Box width={isMobile ? "100%" : "45%"}>
            <Typography
              variant="h4"
              fontWeight="bold"
              color="#3E73DB"
              fontSize={"3rem"}
            >
              97%
            </Typography>
            <Typography fontSize={"0.9rem"}>
              of businesses require people with a mix of technical & human
              skills
            </Typography>
          </Box>

          {/* 3 */}
          <Box width={isMobile ? "100%" : "45%"}>
            <Typography
              variant="h4"
              fontWeight="bold"
              color="#3E73DB"
              fontSize={"3rem"}
            >
              2/3
            </Typography>
            <Typography fontSize={"0.9rem"}>
              of all jobs will be human skill intensive by 2030
            </Typography>
          </Box>

          {/* 4 */}
          <Box width={isMobile ? "100%" : "45%"}>
            <Typography
              variant="h4"
              fontWeight="bold"
              color="#3E73DB"
              fontSize={"3rem"}
            >
              42.6%
            </Typography>
            <Typography fontSize={"0.9rem"}>
              of Indian graduates are employable, largely due to poor
              performance in non-technical skills
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default GrowthLeadershipSection;
